export default __webpack_public_path__ + "static/article-thumbnail-placeholder-e0dce1589aa1318ee3115af9b8378789.jpg";